import { useCallback, useEffect, useState, Fragment } from "react";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { StyledStack } from "./License.style";
import DrawerCM from "components/shared/Drawer";
import Upload from "components/shared/Upload";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import useHttp from "hooks/use-http";
import {
  getLicenseRequest,
  deleteLicenseRequest,
  addLicenseRequest,
} from "api/requests";

function License() {
  const [image, setImage] = useState({ data: [], count: 0 });
  const {
    request,
    loading,
    isUploading,
    setUploadProgress,
    uploadProgress,
    setLoading,
  } = useHttp();

  const onSubmit = async (image) => {
    setLoading(true);
    const res = await request({
      url: () =>
        addLicenseRequest(image, (progress) => setUploadProgress(progress)),
      isFile: true,
      isMulty: true,
    });

    if (res) Toast({ type: "success", title: "آپلود عکس" });
    await getImages(true);
    setLoading(false)
  };

  const handelDelete = async (id) => {
    setLoading(true);
    const res = await request({
      url: deleteLicenseRequest,
      values: id,
      isMulty: true,
    });
    if (res) Toast({ type: "success", title: "حذف" });
    await getImages(true);
    setLoading(false);
  };

  const getImages = useCallback(
    async (stopLoading) => {
      const res = await request({
        url: getLicenseRequest,
        isMulty: stopLoading,
      });

      let transformedData = res.data.map((items) => ({
        id: items.id,
        image: items.image,
      }));

      setImage({ data: transformedData, count: res.count });
    },
    [request]
  );

  useEffect(() => {
    getImages();
  }, [getImages]);

  return (
    <DrawerCM title="گواهینامه ها">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2} spacing={1}>
          <StyledStack>
            <Grid container my={1} spacing={2}>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <Upload
                  refillable
                  onChange={(values) => onSubmit(values)}
                  type="addimage"
                />
              </Grid>
              {image.data.map((items, index) => {
                return (
                  <Grid item lg={4} md={4} sm={6} xs={12} key={"image" + index}>
                    <Upload
                      file={items.image}
                      isWeb
                      type="gallery-images"
                      onDelete={() => handelDelete(items.id)}
                      width="100%"
                      height="100%"
                    />
                  </Grid>
                );
              })}
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
export default License;
